export default __webpack_public_path__ + "static/media/spaceShipF3.a19eb47a.webp";